import {TFunction} from 'i18next';
import {boolean, object, SchemaOf, string} from 'yup';
import {
  envFormInitValues,
  envFormValidationSchema,
  EnvironmentFormFields,
  EnvironmentsFormFields
} from '../Environment.form.model';
import {Environment, EnvironmentAttributes} from '../Environment.model';

export type ShopifyEnvironmentAttributes = EnvironmentAttributes & {
  callbackUrl: string;
  redirectUrl: string;
  shopifyApiKey: string;
  shopifyApiPassword: string;
  live: boolean;
  externalStatusPageEnabled: boolean;
};

export type ShopifyEnvironmentFormFields = EnvironmentFormFields & {
  callbackUrl: string;
  redirectUrl: string;
  shopifyApiKey: string;
  shopifyApiPassword: string;
  live: boolean;
  externalStatusPageEnabled: boolean;
};

export const shopifyEnvFormInitValues = (
  environment: Environment<ShopifyEnvironmentAttributes>
): EnvironmentsFormFields<ShopifyEnvironmentFormFields> => ({
  SHARED: {
    ...envFormInitValues(environment),
    externalStatusPageEnabled: false,
    callbackUrl: environment.attributes.callbackUrl ?? '',
    redirectUrl: environment.attributes.redirectUrl ?? '',
    shopifyApiKey: environment.attributes.shopifyApiKey ?? '',
    shopifyApiPassword: environment.attributes.shopifyApiPassword ?? '',
    live: environment.attributes.live ?? false
  }
});

export const shopifyEnvFormValidationSchema = (t: TFunction): SchemaOf<EnvironmentsFormFields<ShopifyEnvironmentFormFields>> =>
  object().shape({
    SHARED: object().shape({
      ...envFormValidationSchema.fields,
      externalStatusPageEnabled: boolean()
        .required(t('SHARED.FIELD_REQUIRED')),
      redirectUrl: string()
        .required(t('SHARED.FIELD_REQUIRED'))
        .url('Provide valid URL'),
      callbackUrl: string()
        .required(t('SHARED.FIELD_REQUIRED'))
        .url('Provide valid URL'),
      shopifyApiKey: string().required(t('SHARED.FIELD_REQUIRED')),
      shopifyApiPassword: string().required(t('SHARED.FIELD_REQUIRED'))
    }).defined()
  }).defined();
